import React, { FC, useLayoutEffect, useState } from 'react';
import BackButton from '../../../../components/BackButton/BackButton';
import { H2, A, Span } from "../../../../components/Text/Text";
import { useNonDesktopViewport } from '../../../../utils/hooks/useNonDesktopViewport';
import { CampaignWizardMode } from '../../../../models/enums';

import styles from './createProjectHeader.module.scss';

type CreateProjectHeaderPropTypes = {
    currentStep: number;
    mode?: CampaignWizardMode;
}

const CreateProjectHeader: FC<CreateProjectHeaderPropTypes> = (props) => {
    const { currentStep, mode } = props;
    const isCompactHeader = useNonDesktopViewport();
    const [showHelpHint, setShowHelpHint] = useState(!isCompactHeader);

    useLayoutEffect(() => {
        setShowHelpHint(!isCompactHeader);
    }, [isCompactHeader]);

    const toggleShowHelpHint = () => {
        setShowHelpHint(prev => !prev);
    };

    const getTitleBasedOnMode = () => {
        if (mode === CampaignWizardMode.CREATE) return 'Create new campaign';
        if (mode === CampaignWizardMode.COPY) return 'Copy existing campaign';
        return 'Edit campaign'
    };

    return (
        <div>
            <div className={styles.headerWrapper}>
                <div></div>
                <H2 className={styles.header}>
                    {getTitleBasedOnMode()}
                </H2>
                <div className={styles.helpIcon} onClick={toggleShowHelpHint} />
            </div>
            {showHelpHint && (
                <div className={styles.subheader}>
                    <Span>
                        Have you already read the guide to creating a new campaign?
                    </Span>
                    <A href='https://docs.google.com/presentation/d/e/2PACX-1vQmj_6klYpGK8nFlC_oBNXxEWsW5pZnK5dH-wiV5tz2Xcs3Q06ZpKeB85flU1Id_frfvrG442POj5GL/pub?start=false&loop=false&delayms=60000&slide=id.p'>Take a guide tour</A>
                </div>
            )}
        </div>
    );
};

export default CreateProjectHeader;